//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./taskStepView"], function (Marionette, TaskStepView) {
  "use strict";

  var TaskStepController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "taskSteps";
      this.region = options.region;
    },
    show: function (taskSteps) {
      this.view = new TaskStepView.stepsView({ collection: taskSteps });
      this.showRegion(this.view);
    },
  });

  return TaskStepController;
});
